// extracted by mini-css-extract-plugin
export var contentWrap = "fc-regular-content-module--contentWrap--2f050";
export var image = "fc-regular-content-module--image--0e56c";
export var root = "fc-regular-content-module--root--ace0d";
export var title = "fc-regular-content-module--title--5430a";